<template>
    <v-select
        :items="items"
        :label="label"
        :hint="hint"
        :readonly="readonly"
        :value="value"
        :multiple="multiple"
        :rules="requiredRules"
        :class="styleClasses"
        @change="changeItem"
        @input="changeItem"
        >
        <template v-slot:no-data>
          {{$t('warnings.no_data_found')}}
        </template>
    </v-select>
</template>
<script>
import { requiredRules } from '../../utils/rules'
import Servico from '../../services/EmailServerService'

export default {

  name: 'EmailServerSelect',

  methods: {
    changeItem (event) {
      this.$emit('change', event)
    },

    getItems () {
      Servico.findAllIdentifiers()
        .then(response => {
          if (response && response.data) {
            this.items = response.data
          } else {
            this.items = []
          }
        })
        .catch(error => {
          console.error(`${this.$t('warnings.error.occurred')} : ${error}`)
        })
    }
  },

  mounted () {
    this.getItems()
  },

  data: () => {
    return {
      items: []
    }
  },

  model: {
    prop: 'value',
    event: 'change'
  },

  computed: {
    requiredRules () {
      return this.required ? requiredRules(this.value) : []
    }
  },

  props: {
    label: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    styleClasses: {
      type: String,
      default: null
    }
  }
}
</script>
